import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";

export default function HeatLayer({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !points || points.length === 0) return undefined;
    const data = points.map((p) => [p.lat, p.lng, p.intensity || 0.5]);
    const layer = L.heatLayer(data, {
      radius: 35,
      blur: 30,
      minOpacity: 0.35,
      max: 1.0,
      gradient: { 0.3: "#3EB6F0", 0.55: "#F59E0B", 0.8: "#EF4444" },
    });
    layer.addTo(map);
    return () => { map.removeLayer(layer); };
  }, [map, points]);
  return null;
}
